import Accordion from 'accordion-js';

const accordionSections = Array.from(
  document.querySelectorAll('.wp-block-seia-section-accordion')
);

accordionSections.forEach((accordionSection) => {
  const accordions = accordionSection.querySelector('.accordions');
  const expandedByDefaultItems = Array.from(
    accordionSection.querySelectorAll('.accordion.is-expanded')
  );

  const expandedIndexes = expandedByDefaultItems.map((child) =>
    [...accordions.children].indexOf(child)
  );

  const btnExpandAll = accordionSection.querySelector('.button--expand-all');
  const btnCollapseAll = accordionSection.querySelector(
    '.button--collapse-all'
  );

  const accordion = new Accordion(accordions, {
    showMultiple: true,
    elementClass: 'accordion',
    triggerClass: 'accordion__trigger',
    panelClass: 'accordion__panel',
    openOnInit: expandedIndexes,
  });

  if (btnExpandAll) {
    btnExpandAll.addEventListener('click', () => accordion.openAll());
  }

  if (btnCollapseAll) {
    btnCollapseAll.addEventListener('click', () => accordion.closeAll());
  }
});
